module.exports = __webpack_public_path__ + "img/paper-icon.c82159d5.svg";